/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

'use strict';

import Construct from 'can/construct/construct';

export default Construct.extend(
    {
        getItem(key) {
            if (window.sessionStorage) {
                return JSON.parse(window.sessionStorage.getItem(key));
            }
            console.warn('SessionStorage is not available');
            return null;
        },

        setItem(key, value) {
            if (window.sessionStorage) {
                window.sessionStorage.setItem(key, JSON.stringify(value));
            }
        },

        setItemRaw(key, value) {
            window.sessionStorage.setItem(key, value);
        },

        getItemRaw(key, value) {
            window.sessionStorage.getItem(key);
        },

        removeItem(key) {
            if (window.sessionStorage) {
                window.sessionStorage.removeItem(key);
            }
        },
    },
    {},
);
